/**
 * DataTableCellAuthor class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DataTableColumnType, DataTableItemType } from 'Types';
import Tooltip from '@material-ui/core/Tooltip';

export default class DataTableCellAuthor extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        value: PropTypes.any,
        item: DataTableItemType.isRequired,
    };

    /**
     * Render author and co-authors
     *
     * @returns {string}
     */
    renderAuthor = () => {
        const { item } = this.props;

        let result = '';
        if ('profiles' in item && item.profiles.length) {
            const { profiles } = item;
            const [profile] = profiles;

            result = `${profile.first_name} ${profile.last_name}`;

            if (profiles.length > 1) {
                result += ',';

                return (
                    <span>
                        {result}
                        <Tooltip title={item.authors} placement="top">
                            <div>...</div>
                        </Tooltip>
                    </span>
                );
            }
        }

        return result;
    };

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return <div>{this.renderAuthor()}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableCells/DataTableCellAuthor.jsx